import React from "react";
import { FiClock, FiRefreshCw, FiMessageSquare, FiPaperclip } from "react-icons/fi";
import { TbBug, TbDatabaseImport, TbCirclePlus, TbDatabaseEdit } from "react-icons/tb";
import TicketStatusBadge from "../TicketStatusBadge/page";

const formatDate = (dateStr) => {
  if (!dateStr) return "";
  return new Date(dateStr).toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
  });
};

const formatDateTime = (dateStr) => {
  if (!dateStr) return "";
  return new Date(dateStr).toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  });
};

const getTicketTypeIcon = (type) => {
  const t = (type || "").toLowerCase();
  if (t === "defect/bug") return { icon: <TbBug size={20} />, bg: "#fee2e2", color: "#dc2626" };
  if (t === "data migration") return { icon: <TbDatabaseImport size={20} />, bg: "#ede9fe", color: "#7c3aed" };
  if (t === "new requirement") return { icon: <TbCirclePlus size={20} />, bg: "#d1fae5", color: "#059669" };
  if (t === "data correction") return { icon: <TbDatabaseEdit size={20} />, bg: "#fef9c3", color: "#ca8a04" };
  return { icon: <TbDatabaseEdit size={20} />, bg: "#f3f4f6", color: "#6b7280" };
};

const TicketCard = ({ ticket, onClick }) => {
  const {
    ticketNumber, status, priority, ticketType,
    title, client, module, assignee,
    commentCount, attachmentCount,
  } = ticket;

  const { icon, bg, color } = getTicketTypeIcon(ticketType);

  return (
    <div
      onClick={() => onClick && onClick(ticket)}
      style={{
        background: "#fff",
        border: "1px solid #e5e7eb",
        borderRadius: 10,
        padding: "16px 20px",
        cursor: "pointer",
        transition: "box-shadow 0.15s, border-color 0.15s",
        marginBottom: 10,
        display: "flex",
        alignItems: "flex-start",
        gap: 16,
      }}
      onMouseEnter={e => {
        e.currentTarget.style.boxShadow = "0 4px 16px rgba(46,92,184,0.10)";
        e.currentTarget.style.borderColor = "#93c5fd";
      }}
      onMouseLeave={e => {
        e.currentTarget.style.boxShadow = "none";
        e.currentTarget.style.borderColor = "#e5e7eb";
      }}
    >
      {/* LEFT — type icon */}
      <div style={{
        width: 40, height: 40, borderRadius: 10,
        background: bg, color: color,
        display: "flex", alignItems: "center", justifyContent: "center",
        flexShrink: 0, marginTop: 2,
      }}>
        {icon}
      </div>

      {/* RIGHT — all content */}
      <div style={{ flex: 1, minWidth: 0 }}>

        {/* Top row — ticket number + badges */}
        <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap", marginBottom: 8 }}>
          <span style={{ fontSize: 12, fontWeight: 600, color: "#6b7280", fontFamily: "monospace" }}>
            {ticketNumber}
          </span>
          <TicketStatusBadge type="status" value={status} />
          <TicketStatusBadge type="priority" value={priority} />
          {ticketType && <TicketStatusBadge type="ticketType" value={ticketType} />}
        </div>

        {/* Title */}
        <div style={{ fontSize: 14, fontWeight: 600, color: "#111827", marginBottom: 6 }}>
          {title}
        </div>

        {/* Meta — client / module / assignee */}
        <div style={{ display: "flex", gap: 16, fontSize: 12, color: "#6b7280", flexWrap: "wrap", marginBottom: 10 }}>
          <span><span style={{ color: "#9ca3af" }}>Client:</span> {client || "—"}</span>
          <span><span style={{ color: "#9ca3af" }}>Module:</span> {module || "—"}</span>
          <span><span style={{ color: "#9ca3af" }}>Assignee:</span> {assignee || "—"}</span>
        </div>

        {/* Bottom row — dates + counts */}
        <div style={{ display: "flex", alignItems: "center", gap: 16, fontSize: 12, color: "#9ca3af", flexWrap: "wrap" }}>
          {ticket.createdAt && (
            <span style={{ display: "flex", alignItems: "center", gap: 4 }}>
              <FiClock size={12} /> Created {formatDate(ticket.createdAt)}
            </span>
          )}
          {ticket.lastCommentAt && (
            <span style={{ display: "flex", alignItems: "center", gap: 4 }}>
              <FiRefreshCw size={12} /> Updated {formatDateTime(ticket.lastCommentAt)}
            </span>
          )}
          {commentCount > 0 && (
            <span style={{ display: "flex", alignItems: "center", gap: 4 }}>
              <FiMessageSquare size={12} /> {commentCount}
            </span>
          )}
          {attachmentCount > 0 && (
            <span style={{ display: "flex", alignItems: "center", gap: 4 }}>
              <FiPaperclip size={12} /> {attachmentCount}
            </span>
          )}
        </div>

      </div>
    </div>
  );
};

export default TicketCard;